import React from 'react';
import '../styles/PlanIndicator.css';

export default function PlanIndicator({ isLoading, isPro, locale }) {
  return (
    <span className="plan-indicator" aria-busy={isLoading}>
      {isLoading ? (
        <span role="status" aria-label={locale === 'ja' ? 'プランを確認中' : 'Loading plan'}>
          <span className="plan-indicator-spinner" aria-hidden="true" />
        </span>
      ) : (isPro ? 'PRO' : 'FREE')}
    </span>
  );
}
